import Rules from './rules';
import FormRuleManager from "../FormRuleManager.model";

/**
 * @param {string|Node} elt_id
 */
class ImaiosFormSecurity extends FormRuleManager {
    constructor(imaiosForm, rules = []) {
        super(imaiosForm, rules);
    }

    getRulesHandler() {
        return Rules;
    }


    static create(imaiosForm, rules = [])  {
        return new ImaiosFormSecurity(imaiosForm, rules);
    }

    static retrieveRules(formElement) {
        const rulesElements = Array.from(formElement.querySelectorAll('[data-rule="security"]'));
        const rules = rulesElements.map(ruleElement => {
            return ruleElement.getAttribute('data-name');
        });

        return rules;
    }

    async apply() {
        try {
            for (const ruleName in this.rules) {
                const rule = this.rules[ruleName];
                const result = await rule.apply({
                    action: this.getFormID()
                });

                if (result === false) {
                    return  false;
                }
            }
        }
        catch (error) {
            if (
              typeof window.NREUM !== 'undefined' &&
              typeof window.NREUM.noticeError === 'function'
            ) {
                window.NREUM.noticeError(error, { stack: 'prod-dxp', error });
            }
            return false;
        }

        return true;
    }
}

window.ImaiosFormSecurity = ImaiosFormSecurity;
export default ImaiosFormSecurity;
